import { ApiResource } from '@/core/models/api-resource.interface';
import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { Team } from '../../teams/team.interface';
import { EmployerTeamService } from './team.service';

const service = new EmployerTeamService();

export interface EmployerTeamState {
   employerTeamsOverview?: ApiResource<Array<Team>>;
}

const EmployerTeamStore: Module<EmployerTeamState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {
      SET_EMPLOYER_TEAMS_OVERVIEW(state, employerTeamsOverview?: ApiResource<Array<Team>>) {
         state.employerTeamsOverview = employerTeamsOverview;
      },
      ADD_EMPLOYER_TEAM(state, team: Team) {
         state.employerTeamsOverview?.data.push(team);
      },
      DELETE_EMPLOYER_TEAM(state, teamId: number) {
         const index = (state.employerTeamsOverview?.data || []).findIndex((u) => u.id === teamId);
         if (index > -1) state.employerTeamsOverview?.data.splice(index, 1);
      },
   },
   actions: {
      async getEmployerTeams(context, payload: { employerId: number; query?: LocationQuery }) {
         const response = await service.getTeams(payload.employerId, payload.query);
         context.commit('SET_EMPLOYER_TEAMS_OVERVIEW', response);
         return response;
      },
      async addToEmployerTeams(context, payload: { employerId: number; teams: Array<Team> }) {
         const response = await service.addEmployerTeams(payload.employerId, payload.teams);
         response.forEach((team) => {
            context.commit('ADD_EMPLOYER_TEAM', team);
         });
         return response;
      },
      async removeFromEmployerTeams(context, payload: { employerId: number; teams: Array<Team> }) {
         const response = await service.removeEmployerTeams(payload.employerId, payload.teams);
         payload.teams.forEach((team) => {
            context.commit('DELETE_EMPLOYER_TEAM', team.id);
         });
         return response;
      },
   },
};

export default EmployerTeamStore;
